'use strict';

var _flattenIntoArray = require('./flatten-into-array');

var _flattenIntoArray2 = _interopRequireDefault(_flattenIntoArray);

var _arraySpeciesCreate = require('./array-species-create');

var _arraySpeciesCreate2 = _interopRequireDefault(_arraySpeciesCreate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (!Object.prototype.hasOwnProperty.call(Array.prototype, 'flatMap')) {

  Array.prototype.flatMap = function flatMap(callbackFn, thisArg) {
    var o = Object(this);
    if (!callbackFn || typeof callbackFn.call !== 'function') {
      throw TypeError('callbackFn must be callable.');
    }
    var t = thisArg !== undefined ? thisArg : undefined;

    var a = (0, _arraySpeciesCreate2.default)(o, o.length);
    (0, _flattenIntoArray2.default)(a, o,
    /*start*/0,
    /*depth*/1, callbackFn, t);
    return a.filter(function (x) {
      return x !== undefined;
    }, a);
  };
}
//# sourceMappingURL=flat-map.js.map